import { OlJourneyPlace } from '../../lib/types/models/ol/ol-journey-place'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterOlJourneyPlace(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterOlJourneyPlace.url, { id }))
    .get<OlJourneyPlace | null>()
}
